/**
 * 开关量输出
 */
import fvAnimation from "./fvAnimation"
export default class fvOutputSwitch extends fvAnimation {
    constructor(shape){
        super(shape,"fvOutputSwitch");
        this.sizeFunction = AsyncFunction("return " + this.expression + " ? " + this.expression + ":false");
    }

    async run(textDom){
        var size = await this.executionScript(this.sizeFunction);
        if(size == "__defaule"){
            size = "...";
        }
        if(this.enum == true){
            for(var i in this.enuminfo){
              if(size == 1){
                size = 1;
              }else if(size ==false){
                size = 0;
              }
              var value = [i];
              if("no"+size == value[0]){
                textDom.lastElementChild.innerHTML = this.enuminfo[i];
                return;
              }else{
                textDom.lastElementChild.innerHTML =  "";
              }
            }
        }else{
            if(size){
                textDom.lastElementChild.innerHTML = JSON.parse(this.onoff).on;
            }else{
                textDom.lastElementChild.innerHTML = JSON.parse(this.onoff).off;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvOutputSwitch.js